import React, { Component, Fragment } from "react";


class AccountInfos extends Component {
    render() {
      const {nom, prenom, email, societe, rue, cp, localite, pays, tel} = this.props.userinfos;
      return (
        <Fragment>
          <div>
            <h2>{ prenom } { nom} </h2>
            <p>{ rue }<br />{ cp } { localite }<br />{ pays }</p>
            <p>{ email }<br />{ tel } </p>
            <button onClick={ () => this.props.buttonClick() }className="buttonbig">
              Edit infos
            </button>
          </div>
        </Fragment>
      );
    }
}


export default AccountInfos;